export default "__VITE_ASSET__8e69afb8__"